import React from 'react';
import { Grid, Paper, FormControl, InputLabel, Select, MenuItem, Button, Box, Typography } from '@material-ui/core';
import { Skeleton } from '@mui/material';
import TeamFilterHierarchyPlaceHolder from '../../../components/team-filter-hirarchy-for-placeholder';

const RepFilterPanel = ({
  team, fiscalQuarter, teamOptions, teamHierarchy, fiscalQuarterOptions, onTeamChange, onFiscalQuarterChange, onContinue, classes, isTeamMode = false
}) => {
  console.log('teamHierarchy:', teamHierarchy?.parentChildrenTeamFilter?.filters);
  const hasData = teamHierarchy?.parentChildrenTeamFilter?.filters && Array.isArray(teamHierarchy.parentChildrenTeamFilter.filters) && teamHierarchy.parentChildrenTeamFilter.filters.length > 0;

  return (
    <>
      {hasData ? (
        <Grid container spacing={2} style={{ margin: 0 }}>
          <Grid item xs={isTeamMode ? 6 : 7} style={{ padding: 0 }}>
            <Paper className={classes.repTeamFilterContainer} elevation={2} style={{ width: '100%' }}>
              <Grid container spacing={2} alignItems="flex-start">
                {!isTeamMode && (
                  <Grid item xs={4} >
                    <TeamFilterHierarchyPlaceHolder
                      label="Team:"
                      value={team}
                      onTeamChange={onTeamChange}
                      name="team"
                      data={teamHierarchy?.parentChildrenTeamFilter?.filters}
                      disabled={false}
                      labelColorCondition={team.includes("All")}
                      renderValue={selected => {
                        console.log("TeamHierarchy_debug", selected)
                        return selected === "" ? "Please Select a Team" : selected
                      }}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) =>
                        option.parentValue + option.label
                      }
                      showAllOption={true}
                    />
                  </Grid>
                )}
                <Grid item xs={isTeamMode ? 12 : 8} style={{ padding: 0, paddingBootm: 8 }}>
                  <Typography variant="body1" gutterBottom style={{ display: 'block', marginBottom: 4 }}>
                    Select the first fiscal quarter to delete quota for
                  </Typography>
                  <FormControl fullWidth className={classes.formControl}>
                    <Select
                      id="select-fiscalQuarter"
                      value={fiscalQuarter}
                      onChange={onFiscalQuarterChange}
                      displayEmpty
                    >
                      {Array.isArray(fiscalQuarterOptions) && fiscalQuarterOptions.map((fq) => (
                        <MenuItem key={fq.id || fq.fiscal_quarter || fq} value={fq.id || fq.fiscal_quarter || fq}>
                          {fq}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} container justifyContent='flex-end'>
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button
                variant="contained"
                color="primary"
                disabled={(!isTeamMode && team.length <= 0) || !fiscalQuarter}
                onClick={onContinue}
              >
                Continue
              </Button>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Skeleton width="100%" height={150} />
      )}
    </>
  );
};

export default RepFilterPanel;